// @flow
import React, { useEffect, useState } from 'react';
// Components
import FormControlInput from './FormControlInput';
// Helpers
import { formatPhoneNumber, sanitizePhoneNumber } from '../commonHelpers';
import validationHelpers from '../validationHelpers';
// Types
import type { FieldErrors, ServerErrors } from '../../types/ServerErrors';
// Styles
import './PhoneInput.css';

const SERVER_ERROR_KEYS = ['phone', 'phones.number', 'telephone'];

const getFieldErrors = (serverErrors: ?ServerErrors): FieldErrors => {
  if (!serverErrors) return {};
  const nested = serverErrors.errors;
  return nested && typeof nested === 'object' ? nested : serverErrors;
};

type Props = {
  value: string,
  onChange: (value: string) => void,
  errorMessage?: string,
  serverErrors?: ?ServerErrors,
  validate?: (value: string) => string,
  label?: string,
  isRequired?: boolean,
  autocomplete?: string,
  disabled?: boolean,
};

const PhoneInput = ({
  value,
  onChange,
  errorMessage = '',
  serverErrors,
  validate = validationHelpers.phone,
  label = 'Telefone',
  isRequired = false,
  autocomplete = 'tel',
  disabled,
}: Props) => {
  const [blurError, setBlurError] = useState('');
  const [serverErrorsDismissed, setServerErrorsDismissed] = useState(false);

  useEffect(() => {
    setServerErrorsDismissed(false);
  }, [serverErrors]);

  const handleChange = (text: string) => {
    setBlurError('');
    setServerErrorsDismissed(true);
    onChange(text.trim().startsWith('+') ? text : sanitizePhoneNumber(text));
  };

  const fieldErrors = getFieldErrors(serverErrors);
  const serverKey = SERVER_ERROR_KEYS.find(key => fieldErrors[key]);
  const serverError =
    serverKey && !serverErrorsDismissed
      ? [].concat(fieldErrors[serverKey])[0]
      : '';

  return (
    <div className="phone-input">
      <FormControlInput
        type="tel"
        variant="rounded"
        label={label}
        value={formatPhoneNumber(value)}
        isRequired={isRequired}
        autocomplete={autocomplete}
        disabled={disabled}
        handleChangeText={handleChange}
        handleBlur={() => setBlurError(validate(value))}
        errorMessage={errorMessage || blurError || serverError}
      />
    </div>
  );
};

export default PhoneInput;
